import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const toastIcons: ToasterProps["icons"] = {
  success: <CircleCheckIcon className="size-5 text-positive" />,
  info: <InfoIcon className="size-5 text-primary" />,
  warning: <TriangleAlertIcon className="size-5 text-warning" />,
  error: <OctagonXIcon className="size-5 text-destructive" />,
  loading: <Loader2Icon className="size-5 animate-spin text-muted-foreground" />,
};

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner position="bottom-right" closeButton richColors={false} duration={5000} icons={toastIcons} {...props} />
  );
}

export { Toaster };
